import React, { useEffect, useState } from 'react';
// import Select, { components } from 'react-select';
import Select from 'react-select';
import { customStyles } from './DropdownCustomStyle';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import classes from './Dropdown.module.css';
import '../../../App.css';

const Dropdown = ({
  disabled=false,
  defaultValues,
  picklistOptions,
  isMultiselect,
  onValueChange,
  placeholder,
  isClearable = false,
  required,
  invalid,
  className,
  completeBorder,
  isSearchable=true,
  ErrorMessage='',
  isNewOptionValid=false
  
}) => {
  const [inputValue, setInputValue] = React.useState('');
  const [selectedVal, setSelectedVal] = React.useState(defaultValues);
  const [optionList, setOptionList] = useState(picklistOptions)

  useEffect(() => {
    setOptionList(picklistOptions);
  }, [picklistOptions]);

  const onInputChange = (selectedVal, event) => {
    if (
      event &&
      (event.action !== 'input-blur' && event.action !== 'menu-close')
    ) {
      setInputValue(selectedVal);
    }

    if (event && event.action === 'input-blur' && isNewOptionValid !== false) {
      onSelectedValueChange();
    }
  };

  const onTaborEnterKeyDown = event => {
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        onSelectedValueChange();
        break;
      default:
        return null;
    }
  };

  const onSelectedValueChange = () => {
    if (inputValue) {
      let newOption = { label: inputValue, value: inputValue };
      if (!optionList.find(option => option.value === inputValue)) {
        setOptionList(prevOptions => [...prevOptions, newOption]);
      }
      onValueChange(newOption);
    }

    if (isClearable) {
      setInputValue('');
    }
  };

  const onSelect = value => {
    onValueChange(value);
    setSelectedVal(value);

    if (isClearable) {
      setSelectedVal('');
    }
  };
  return (
    <>
    <div className={`${classes['container']} ${className}`}>
      {required ? <span className={classes['asterisk']}>*</span> : null}
      <div
        className={`${classes.content} ${invalid ? classes.invalid : ''} ${
          completeBorder ? classes['complete-border'] : ''
        }`}
        style={{ width: '100%', minWidth:"7vw"}}
      >
        <Select
          value={selectedVal}
          options={optionList}
          isMulti={isMultiselect}
          onChange={val => onSelect(val)}
          styles={customStyles}
          // styles={{fontSize:"10px"}}
          placeholder={placeholder}
          inputValue={inputValue}
          onInputChange={(val, event) => onInputChange(val, event)}
          onKeyDown={onTaborEnterKeyDown}
          // components={{ DropdownIndicator, Option }}
          closeMenuOnSelect={!isMultiselect}
          hideSelectedOptions={false}
          backspaceRemovesValue={false}
          isSearchable={isSearchable}
          isDisabled={disabled}
          isValidNewOption={(inputValue) => isNewOptionValid !== false && inputValue.trim() !== ""}
        />
      </div>
    </div>
    {invalid?ErrorMessage:''}
    </>
  );
};

export default Dropdown;
